export const places = 'v1/place/search?';
export const excludes = 'v1/place/manualUrl/';
export const placesElastic = 'v1/place/elastic/';
export const nearestTown = 'v1/place/nearesttown?';
export const result = 'v1/escrutinio';
export const historic = 'v1/election/historic';
export const twitter = 'v1/twitter/info';
export const politicalParties = 'v1/politicalparty/matchparties';
